module.exports = __webpack_public_path__ + "static/img/Astral.02a6a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Astral.jpg
// module id = 6oGF
// module chunks = 1